/**
 * Created by cate on 24-08-17.
 */
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[warehouse-params-form]',
})
export class WarehouseParamsFormDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse-params-form.directive.ts